import request from '@/utils/request';

// 编辑版本
export function updateVersion(id, options) {
  return request({
    url: '/op/activityVersion/' + id,
    method: 'POST',
    data: options
  });
}
// 版本的启用与禁用
export function versionStatus(id, options) {
  return request({
    url: '/op/activityVersion/modifyStatus/' + id,
    method: 'POST',
    data: options,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}
// 添加版本
export function addVersion(options) {
  return request({
    url: '/op/activityVersion/',
    method: 'POST',
    data: options
  });
}
// 编辑应用
export function updateApp(id, options) {
  return request({
    url: '/op/activityApp/' + id,
    method: 'POST',
    data: options
  });
}
// 添加应用
export function addApp(options) {
  return request({
    url: '/op/activityApp/',
    method: 'POST',
    data: options
  });
}
// 应用编码
export function appCode(options) {
  return request({
    url: '/op/activityApp/getAppCpde',
    method: 'get',
    params: options
  });
}

// 查询版本管理列表
export function versionList(options) {
  return request({
    url: '/op/activityVersion/',
    method: 'get',
    params: options
  });
}

// 获取获取应用分类列表
export function appList(options) {
  return request({
    url: '/op/activityApp/',
    method: 'get',
    params: options
  });
}

